import { FC, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AlertBox, InvestigationHistoryRaw } from '@/components';
import { InvestigationHistoryItemData } from '@/redux/models';
import { mapInvestigationItem } from '@/redux/mappers/investigationHistoryMappers';
import {
  amlbotAPI,
  GetAmlHistoryItemResultRequest,
  GetAmlHistoryItemResultResponse,
} from '@/api';
import { useApiCall } from '@/hooks';
import { ToastContainer } from 'react-toastify';
import { COMMON_CONTAINER_ID } from '@/config';
import { useTranslation } from 'react-i18next';

import styles from './InvestigationResultViewer.module.sass';

interface InvestigationSinglePageProps {}

const InvestigationSinglePage: FC<InvestigationSinglePageProps> = () => {
  const { t } = useTranslation();
  const { userData = '', responseData = '' } = useParams();
  const [amlHistoryItem, setAmlHistoryItem] =
    useState<InvestigationHistoryItemData>();

  const [getInvestigation, loading, error] = useApiCall(async () => {
    const payload: GetAmlHistoryItemResultRequest = {
      userData,
      responseData,
    };
    const response: GetAmlHistoryItemResultResponse =
      await amlbotAPI.fetchAmlHistoryItemResult(payload);

    if (response.success) {
      setAmlHistoryItem(() => mapInvestigationItem(response.data.data));
    }
  });

  useEffect(() => {
    getInvestigation();
  }, []);

  if (loading) {
    return <Suspense />;
  }

  return (
    <>
      {!!error && (
        <div className={styles.result}>
          <div className={styles.main}>
            <AlertBox type="danger">
              {{
                title: t('translation.error'),
                description: error,
              }}
            </AlertBox>
          </div>
        </div>
      )}

      {!error && <InvestigationHistoryRaw item={amlHistoryItem} />}
      <ToastContainer
        containerId={COMMON_CONTAINER_ID}
        position="top-center"
        limit={3}
        enableMultiContainer
      />
    </>
  );
};

export default InvestigationSinglePage;
